// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"6e959dc9","629":"b3bd7431"}[chunkId] + ".chunk.js";
};